module.exports = __webpack_public_path__ + "static/media/arrow-down-sort-light.0d8e1056.svg";